/**
 * Shallow equality check that compares object properties by reference.
 * Returns true if both objects have the same keys and all values are strictly equal (===).
 *
 * @param a - First object to compare
 * @param b - Second object to compare
 * @returns true if objects are shallowly equal, false otherwise
 */
export const shallowEqual = (
  a: Record<string, unknown>,
  b: Record<string, unknown>,
): boolean => {
  if (a === b) return true;

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) return false;

  return keysA.every(
    key => Object.prototype.hasOwnProperty.call(b, key) && a[key] === b[key],
  );
};
